import React from 'react';
import $ from 'jquery';
import {TweenMax, TimelineMax} from "gsap";
import ScrollMagic from 'scrollmagic';
import "../node_modules/scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js";



function tweenAnimate(listItemsArray) {
	 var tween = TweenMax.staggerFromTo(listItemsArray,.6,{opacity:0},{opacity:1},.5);
	 return tween;
}

class Banner extends React.Component {
        render() {
          return (
          	<section className="team about-team">
			  <div className="teaminner2">
			    <div className="teaminner">
			      <div className="teaminnermain">
			        <div className="container">
			          <div className="row">
			            <div className="col-md-7 breeserif titletext">
			              <h1 className="breeserif titletext">We’re in Your Corner.<br />&nbsp;</h1>
			            </div>
			            <div className="col-md-5 visible-lg"><img src="images/MVP-Hero-Circle-2.png" alt="" className="img-responsive center-block" /></div>
			          </div>
			        </div>
			      </div>
			    </div>
			  </div>
			</section>
          );
        }
}

class MainContent extends React.Component {
		componentDidMount() {
			$('.why-block').css({opacity:0});
	      	var listItems=$('.why-block'),listItemsArray=listItems.toArray();
	       	var tween=tweenAnimate(listItemsArray);
	       	var controller = new ScrollMagic.Controller();
	       	var scene = new ScrollMagic.Scene({
	                        triggerElement: ".why-block",
	                        offset:-400
	                      })
	                      .setTween(tween) // trigger a TweenMax.to tween
	                      .addTo(controller);
    	}
        render() {
          return (
          	<div>
          		<div className="container">
				  <div className="infobox-video">
				    <div className="row pad-top-40">
				      <div className="col-sm-12">
				        <h1><span className="video-bg">Our Priorities Align with Yours</span></h1>

				      </div>
				    </div>
				  </div>
				</div>
				<div className="container">
				  <div className="infobox">
				    <div className="row">
						<div className="col-sm-1"></div>
				      <div className="col-sm-10">	  
						  <p className="flamaitalic font24 pad-bot-20">We are dedicated to long-term results and relationships.</p>
						  <p className="flamalight font21">Staffing is a people business. We value and nurture the relationships we have with our clients, both our employee candidates and the small, mid-size and Fortune 500 companies we engage with on a daily basis. In every exchange, we offer our respect, expertise and professionalism. </p>
				      </div>
				    </div>
				  </div>
				</div>

				<div className="container">
				<section className="save col-md-6 why-block" style={{"minHeight":"600px"}}>
					<div className="col-sm-1"></div>
				    <div className="col-sm-10 pad-top-40">
				        <h1 className="breeserif">Save time and money:</h1>
				        <p className="flamaitalic font24 pad-bot-20">We are experienced staffing specialists who take advantage of today’s lead recruiting tools and resources that enable us to recruit the qualified employees you need.</p>
				        <p className="flamalight font21">Today’s landscape can be unpredictable, and rapid turnover rates present an ongoing challenge. Outsourcing hiring needs to MVP simplifies the effort and avoids draining valuable time and financial resources caused by navigating the process internally.</p>
				    </div>
				    <div className="col-sm-1"></div>
				</section>
				<section className="reduce col-md-6 why-block" style={{"minHeight":"600px"}}>
					<div className="col-sm-1"></div>
				    <div className="col-sm-10 pad-top-40">
				        <h1 className="breeserif">Reduce risk and paperwork:</h1>
				        <p className="flamaitalic font24 pad-bot-20">To alleviate stress and risks, MVP hires the Temporary and Temp-to-Perm, workers as our own employees.</p>
				        <p className="flamalight font21">We’ll handle payroll and taxation, employee issues, benefit costs, legal and ACA risks. We’re dedicated to serving as a partner for our clients to make the search for reliable, quality candidates as seamless as possible.</p>
				    </div>
				    <div className="col-sm-1"></div>
				</section>
				</div>

				<div className="container">
				<section className="rely col-md-6 why-block" style={{"minHeight":"600px"}}>
					<div className="col-sm-1"></div>
				    <div className="col-sm-10 pad-top-40">
				        <h1 className="breeserif">Rely on our stability:</h1>
				        <p className="flamaitalic font24 pad-bot-20">We support businesses far and wide, big and small. And we’re continuing to grow.</p>
				        <p className="flamalight font21">MVP offers exceptional operational stability to small, mid-size and Fortune 500 companies within 300 established onsite programs.</p>
				    </div>
				    <div className="col-sm-1"></div>
				</section>
				<section className="benefit col-md-6 why-block" style={{"minHeight":"600px"}}>
					<div className="col-sm-1"></div>
				    <div className="col-sm-10 pad-top-40">
				        <h1 className="breeserif">Benefit from our flexibility and responsiveness:</h1>
				        <p className="flamaitalic font24 pad-bot-20">We pride ourselves on our ability to remain nimble and accommodating throughout the evolving needs and priorities of hiring sprees.</p>
				        <p className="flamalight font21">After all, you can’t always predict how many people you need and when you need them. But you can guarantee that MVP will handle any situation.</p>
				    </div>
				    <div className="col-sm-1"></div>
				</section>
				</div>
          	</div>
          );
        }
}





function Why() {
  return (
  <div>
      <Banner />
      <MainContent />
  </div>    
  );
}

export default Why


// WEBPACK FOOTER //
// ./src/why.js